import {useLazyQuery, useMutation, useQuery} from '@apollo/client'
import {
  DELETE_MANY_FEEDBACKS,
  FETCH_PAGINATED_FEEDBACKS,
  GET_FEEDBACK_BY_ID,
} from '../queries/feedback.query'
import {Feedback} from '../types/feedback.type'

export const useFeedbackById = (id?: string) => {
  const {data, loading, error, refetch} = useQuery(GET_FEEDBACK_BY_ID, {
    variables: {id},
    skip: !id,
    fetchPolicy: 'network-only',
  })

  const response = data?.getFeedbackByIDR

  return {
    feedback: (response?.feedback ?? undefined) as Feedback | undefined,
    message: response?.message as string | undefined,
    loading,
    error,
    refetch,
  }
}

const useFeedback = () => {
  const [getUserFeedbacks] = useLazyQuery(FETCH_PAGINATED_FEEDBACKS)

  const [deleteFeedbacks] = useMutation(DELETE_MANY_FEEDBACKS)
  const getFeedbacks = async (
    page: number,
    pageSize: number,
    startDate: string,
    endDate: string,
    searchString: string,
    subscription: string
  ) => {
    try {
      const request = {
        variables: {
          page,
          pageSize,
          startDate,
          endDate,
          searchString,
          subscriptionStatus: subscription,
        },
      }

      const {data, error} = await getUserFeedbacks(request)

      console.log(data, 'response')
      return {
        data,
        error,
      }
    } catch (error: any) {
      console.log(error, 'error')
      throw new Error(error)
    }
  }

  const deleteManyFeedbacks = async (ids: string[]) => {
    try {
      const request = {
        variables: {
          ids,
        },
      }

      const {data, errors} = await deleteFeedbacks(request)
      return {
        data,
        errors,
      }
    } catch (error: any) {
      throw new Error(error)
    }
  }

  return {
    getFeedbacks,
    deleteManyFeedbacks,
  }
}

export default useFeedback
